/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} HourInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} hour" |
* | "other" | "{count} hours" |
*
* @param {HourInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const hour = /** @type {((inputs: HourInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HourInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} hour`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} hours`);
		return /** @type {LocalizedString} */ ("hour");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} heure`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} heures`);
		return /** @type {LocalizedString} */ ("hour");
	}
});